import React, { useEffect, useRef, createElement } from 'react';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
// Helper to track AddToCart event from anywhere
export const trackAddToCart = () => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'AddToCart');
  }
};
export function MetaPixel() {
  const initialized = useRef(false);
  useEffect(() => {
    if (initialized.current) return;
    initialized.current = true;
    if (!window.fbq) {
      window.fbq = function () {
        window.fbq.callMethod ? window.fbq.callMethod.apply(window.fbq, arguments) : window.fbq.queue.push(arguments);
      };
      if (!window._fbq) window._fbq = window.fbq;
      window.fbq.push = window.fbq;
      window.fbq.loaded = true;
      window.fbq.version = '2.0';
      window.fbq.queue = [];
    }
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    window.fbq('init', '1019130347317304');
    window.fbq('track', 'PageView');
  }, []);
  return <noscript data-id="element-173">
      <img height="1" width="1" style={{
      display: 'none'
    }} src="https://www.facebook.com/tr?id=1019130347317304&ev=PageView&noscript=1" alt="" data-id="element-174" />
    </noscript>;
}